import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const displayPathStart = 'Catalogs|Benefits|Instructions|';
const labeStart = 'Label for field: ';
const sharedLocProperties: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Benefit,
};

export type BenefitInstructionsLocs =
	| 'SPBenefitInstructionsTitle'
	| 'SPBenefitInstructionsEditButton'
	| 'SPBenefitInstructionsCancelButton'
	| 'SPBenefitInstructionsUpdateButton'
	| 'SPBenefitInstructionsCreateButton'
	| 'SPBenefitInstructionsLabelCulture'
	| 'SPBenefitInstructionsAddLanguageButton'
	| 'SPBenefitInstructionsNoInstructions'
	| 'SPBenefitInstructionsCreateSuccess'
	| 'SPBenefitInstructionsUpdateSuccess'
	| 'SPBenefitInstructionsLabelInstructions'
	| 'SPBenefitInstructionsLabelDescription';

export const spBenefitInstructionsLocs: LocDefs<BenefitInstructionsLocs> = {
	SPBenefitInstructionsTitle: {
		defaultValue: 'Benefit Description and Instructions',
		displayType: 'Title',
		description: 'Title for the benefit instructions page.',
		displayPath: `${displayPathStart}Title`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Title.Section',
		...sharedLocProperties,
	},
	SPBenefitInstructionsEditButton: {
		defaultValue: 'Edit Details',
		displayType: 'Button',
		description: 'Button to edit the instructions.',
		displayPath: `${displayPathStart}Edit`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.EditDetails',
		...sharedLocProperties,
	},
	SPBenefitInstructionsCancelButton: {
		defaultValue: 'Cancel',
		displayType: 'Button',
		description: 'Button to cancel the instruction edits.',
		displayPath: `${displayPathStart}Cancel`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.Cancel',
		...sharedLocProperties,
	},
	SPBenefitInstructionsUpdateButton: {
		defaultValue: 'Update Description and Instructions',
		displayType: 'Button',
		description: 'Button to update the instruction edits.',
		displayPath: `${displayPathStart}Update`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.Update',
		...sharedLocProperties,
	},
	SPBenefitInstructionsCreateButton: {
		defaultValue: 'Create Description and Instructions',
		displayType: 'Button',
		description: 'Button to add instruction edits.',
		displayPath: `${displayPathStart}Create`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.Create',
		...sharedLocProperties,
	},
	SPBenefitInstructionsLabelCulture: {
		defaultValue: 'Language',
		displayType: 'Label',
		description: `${labeStart}Language`,
		displayPath: `${displayPathStart}Update`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.Update',
		...sharedLocProperties,
	},
	SPBenefitInstructionsLabelInstructions: {
		defaultValue: 'Instructions',
		displayType: 'Label',
		description: `${labeStart}Instructions`,
		displayPath: `${displayPathStart}Instructions`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.FieldLabel.Instructions',
		...sharedLocProperties,
	},
	SPBenefitInstructionsLabelDescription: {
		defaultValue: 'Description',
		displayType: 'Label',
		description: `${labeStart}Description`,
		displayPath: `${displayPathStart}Description`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.FieldLabel.Description',
		...sharedLocProperties,
	},
	SPBenefitInstructionsAddLanguageButton: {
		defaultValue: 'Add Language',
		displayType: 'Button',
		description: 'Button to add language',
		displayPath: `${displayPathStart}Add Language`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.AddLanguage',
		...sharedLocProperties,
	},
	SPBenefitInstructionsNoInstructions: {
		defaultValue: 'No descriptions or instructions added',
		displayType: 'Content',
		description: `Content shown when there is no Description`,
		displayPath: `${displayPathStart}NoInstructions`,
		legacyName: 'Benefit/Catalogs.BenefitsInstructions.Button.NoInstructions',
		...sharedLocProperties,
	},
	SPBenefitInstructionsCreateSuccess: {
		defaultValue: 'Instructions and description successfully added',
		displayType: 'Notification',
		description: 'Notification shown when instructions are successfully added',
		displayPath: `${displayPathStart}Instructions Added`,
		legacyName: 'Benefits/Catalogs.BenefitsInstructions.NotificationMessage.CreateSuccess',
		...sharedLocProperties,
	},
	SPBenefitInstructionsUpdateSuccess: {
		defaultValue: 'Instructions and description successfully updated',
		displayType: 'Notification',
		description: 'Notification shown when instructions are successfully updated',
		displayPath: `${displayPathStart}Instructions Updated`,
		legacyName: 'Benefits/Catalogs.BenefitsInstructions.NotificationMessage.UpdateSuccess',
		...sharedLocProperties,
	},
};

export const LOC_KEYS = MapLocKeys<BenefitInstructionsLocs>(spBenefitInstructionsLocs);
export type SPBenefitInstructionsLocsType = LocMap<BenefitInstructionsLocs>;
